import gql from 'graphql-tag'

export const ListSanctionedPlateTime = gql`
    query getSanctionedByFacility($installationId:ID!){
       getSanctionedByFacility(installationId:$installationId){
         id
         start_date
         end_date
         status
  }
}
`
export const createSanctionedTimeMutation = gql`
    mutation createSanctionedTime($startDate:String!,$endDate:String!,$installationId:ID!){
        createSanctionedTime(startDate:$startDate,endDate:$endDate,installationId:$installationId)
}
`

export const getSanctionedTimeById = gql`
    query getSanctionedById($id:ID!){
      getSanctionedById(id:$id){
        start_date
        end_date
      }
    }
`

export const updateSanctionedTimeMutation = gql `
mutation updateSanctionedTimeById($input:UpdateSanctionedTimeInput!){
  updateSanctionedTimeById(input:$input)
}
`

export const deleteSanctionedTimeMutation = gql`
  mutation deleteSanctionedTimeOnly($id:ID!, $installationId:ID!){
    deleteSanctionedTimeOnly(id:$id, installationId:$installationId)
}
`
